import routes from '../routes'
import * as queryString from 'query-string'

export const redirectToLogin = (email: string): void => {
  const params = queryString.stringify({
    email,
    cxLoginBanner: true,
  })

  window.location.assign(`${routes.login.path}?${params}`)
}
